import { useIsFirstRender } from './useIsFirstRender';
var useBeforeMount = function (callback) {
    var isFirstRender = useIsFirstRender();
    if (isFirstRender) {
        callback();
    }
};
export { useBeforeMount };
